import React from 'react';
import { Link as GatsbyLink } from 'gatsby';
import { TranslatedLink as TranslateLink } from 'gatsby-plugin-translate-urls';
import { isMultilingual } from '../../languages';

// eslint-disable-next-line react/prop-types
export const Link = ({ to, children, ...props }) => {
  if (isMultilingual) {
    // Utilise TranslatedLink pour les langues autres que FR
    return (
      <TranslateLink to={to} {...props}>
        {children}
      </TranslateLink>
    );
  }
  // Utilise GatsbyLink pour FR
  return (
    <GatsbyLink to={to} {...props}>
      {children}
    </GatsbyLink>
  );
};

export default Link;
